/**
 * HDN · Galería de la ficha (paquete B), como la del tema anterior (Ella: slick con slider-for,
 * slider-nav y jQuery zoom), sobre el carrusel de Horizon y sin jQuery:
 * - Flechas en los extremos de las miniaturas (snippets/slideshow-controls.liquid): foto anterior o
 *   siguiente, en bucle como el anterior.
 * - La miniatura elegida queda la primera de la tira (slick la ponía a la izquierda; Horizon la
 *   centra), también al pasar la foto con el dedo.
 * - Lupa al pasar el ratón: la foto se amplía ×1,35 dentro de su recuadro y sigue al puntero (el
 *   CSS está en src/hdn-tailwind.css). Al entrar se pide la foto al doble de ancho para que no se vea
 *   borrosa. Solo con ratón y sin «reducir movimiento». El clic sigue abriendo el visor de Horizon.
 */

const conRaton = window.matchMedia('(hover: hover) and (pointer: fine)');
const menosMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)');

/** Flechas de las miniaturas: un solo escuchador para toda la página. */
document.addEventListener('click', (event) => {
  const flecha = event.target.closest('[data-hdn-miniaturas]');
  if (!flecha) return;
  const carrusel = flecha.closest('slideshow-component');
  const total = carrusel?.slides?.length ?? 0;
  if (!carrusel || total < 2) return;
  const paso = Number(flecha.dataset.hdnMiniaturas) || 1;
  carrusel.select((carrusel.current + paso + total) % total);
});

/** La miniatura elegida, la primera de la tira (después de que Horizon la centre). */
document.addEventListener('slideshow:select', (event) => {
  const carrusel = event.target.closest?.('media-gallery slideshow-component');
  if (!carrusel) return;
  const tira = carrusel.querySelector('.slideshow-controls__thumbnails-container');
  const miniatura = carrusel.querySelectorAll('.slideshow-controls__thumbnail')[event.detail?.index ?? carrusel.current];
  if (!tira || !miniatura) return;
  const relleno = parseFloat(getComputedStyle(miniatura.parentElement).paddingInlineStart) || 0;
  tira.scrollTo({ left: miniatura.offsetLeft - relleno, behavior: menosMovimiento.matches ? 'instant' : 'smooth' });
});

/** Lupa al pasar el ratón por la foto principal. */
function lupa(diapositiva) {
  if (diapositiva.dataset.hdnLupaLista) return;
  diapositiva.dataset.hdnLupaLista = '';
  let pendiente = 0;
  let x = 50;
  let y = 50;

  const mover = () => {
    pendiente = 0;
    diapositiva.style.setProperty('--hdn-lupa-x', `${x}%`);
    diapositiva.style.setProperty('--hdn-lupa-y', `${y}%`);
  };

  diapositiva.addEventListener('pointerenter', (event) => {
    if (event.pointerType !== 'mouse' || !conRaton.matches || menosMovimiento.matches) return;
    const foto = diapositiva.querySelector('.product-media img');
    if (foto && !foto.dataset.hdnLupaGrande) {
      // La foto al doble de ancho de su recuadro, para que ampliada no se vea borrosa.
      foto.dataset.hdnLupaGrande = '';
      foto.sizes = `${Math.round(foto.getBoundingClientRect().width * 2)}px`;
    }
    diapositiva.toggleAttribute('data-hdn-lupa', true);
  });

  diapositiva.addEventListener('pointermove', (event) => {
    if (!diapositiva.hasAttribute('data-hdn-lupa')) return;
    const caja = diapositiva.getBoundingClientRect();
    x = Math.min(100, Math.max(0, ((event.clientX - caja.left) / caja.width) * 100));
    y = Math.min(100, Math.max(0, ((event.clientY - caja.top) / caja.height) * 100));
    if (!pendiente) pendiente = requestAnimationFrame(mover);
  });

  diapositiva.addEventListener('pointerleave', () => {
    diapositiva.removeAttribute('data-hdn-lupa');
  });
}

function prepararLupas(raiz = document) {
  raiz.querySelectorAll('media-gallery slideshow-slide.product-media-container--zoomable').forEach(lupa);
}

prepararLupas();
// La ventana rápida y el editor de temas pintan galerías después de cargar la página.
new MutationObserver((cambios) => {
  for (const cambio of cambios) {
    for (const nodo of cambio.addedNodes) {
      if (nodo instanceof Element && (nodo.matches('media-gallery') || nodo.querySelector('media-gallery'))) prepararLupas(nodo);
    }
  }
}).observe(document.body, { childList: true, subtree: true });
